import { CInput } from "@coreui/react"
import PropTypes from "prop-types"
import React from "react"

export default function Pagination({
  itemsPerPage,
  currentPage,
  setCurrentPage,
  noOfPages,
  noOfRecords,
  className = ""
}) {
  // const handleClick = (event) => {
  //   setCurrentPage(parseInt(event.target.id))
  // }

  // const renderPageNumbers = [...range(1, noOfPages + 1)].map((page) => {
  //   if (page < maxLimit + 1 && page > minLimit) {
  //     return (
  //       <li key={page} id={page} onClick={handleClick} className={currentPage === page ? "active" : null}>{page}</li>
  //     )
  //   } else {
  //     return null
  //   }
  // })

  const handlePrevBtn = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)

      // if ((currentPage - 1) % pageNumberLimit === 0) {
      //   setMaxLimit(maxLimit - pageNumberLimit)
      //   setMinLimit(minLimit - pageNumberLimit)
      // }
    }
  }

  const handleNxtBtn = () => {
    if (currentPage < noOfPages) {
      setCurrentPage(currentPage + 1)

      // if (currentPage + 1 > maxLimit) {
      //   setMaxLimit(maxLimit + pageNumberLimit)
      //   setMinLimit(minLimit + pageNumberLimit)
      // }
    }
  }

  // let beforeDot = null
  // if (currentPage > pageNumberLimit) {
  //   beforeDot = <li>&hellip;</li>
  // }

  // let afterDot = null
  // if (maxLimit < noOfPages) {
  //   afterDot = <li>&hellip;</li>
  // }

  // const onRecordsChange = (e) => {
  //   setItemsPerPage(e.target.value)
  //   setCurrentPage(1)
  //   setMinLimit(0)
  //   setMaxLimit(5)
  // }

  const onInputChange = (e) => {
    const val = parseInt(e.target.value) || ""
    if (val <= noOfPages) {
      setCurrentPage(val)
    }
  }

  const totalRecordsOnCurrentPage = itemsPerPage * currentPage
  const startingRecordOnCurrentPage =
    totalRecordsOnCurrentPage - itemsPerPage + 1

  return (
    <>
      <ul
        className={`pagination ${className} mr-0 d-flex col-md-7 justify-content-end`}
      >
        <li
          onClick={() => setCurrentPage(1)}
          tabIndex={0}
          className="pagination-arrow py-0"
        >
          &laquo;
        </li>
        <li
          onClick={handlePrevBtn}
          data-testid="left-button"
          tabIndex={0}
          className="pagination-arrow py-0"
        >
          &lsaquo;
        </li>
        {/* {beforeDot}
        {renderPageNumbers}
        {afterDot} */}
        <CInput
          value={currentPage}
          className="pagination-input h-75 align-self-center ml-2"
          min={1}
          tabIndex={0}
          max={noOfPages}
          onChange={onInputChange}
        />
        <span className="d-flex align-items-center mx-2"> to {noOfPages} </span>
        <li
          onClick={handleNxtBtn}
          data-testid="right-button"
          tabIndex={0}
          className="pagination-arrow py-0"
        >
          &rsaquo;
        </li>
        <li
          className="pagination-arrow py-0"
          tabIndex={0}
          onClick={() => setCurrentPage(noOfPages)}
        >
          &raquo;
        </li>
      </ul>
      <span className="d-flex flex-fill align-items-center justify-content-end mr-4">
        {startingRecordOnCurrentPage} to{" "}
        {totalRecordsOnCurrentPage > noOfRecords
          ? noOfRecords
          : totalRecordsOnCurrentPage}{" "}
        of {noOfRecords}
      </span>
    </>
  )
}

Pagination.propTypes = {
  itemsPerPage: PropTypes.number,
  currentPage: PropTypes.number,
  setCurrentPage: PropTypes.func,
  noOfPages: PropTypes.number,
  noOfRecords: PropTypes.number,
  className: PropTypes.string
}
